import { render, staticRenderFns } from "./AdminQueueHealthWidget.vue?vue&type=template&id=5efef45c&scoped=true&"
import script from "./AdminQueueHealthWidget.vue?vue&type=script&lang=js&"
export * from "./AdminQueueHealthWidget.vue?vue&type=script&lang=js&"
import style0 from "./AdminQueueHealthWidget.vue?vue&type=style&index=0&id=5efef45c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efef45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5efef45c')) {
      api.createRecord('5efef45c', component.options)
    } else {
      api.reload('5efef45c', component.options)
    }
    module.hot.accept("./AdminQueueHealthWidget.vue?vue&type=template&id=5efef45c&scoped=true&", function () {
      api.rerender('5efef45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminQueueHealthWidget.vue"
export default component.exports